<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication" role="doc-dedication">
<p class="ded"><span aria-label="page v" epub:type="pagebreak" id="page_v" role="doc-pagebreak"><i>To Lucy, without whose unstinting and generous efforts as proofreader, fact checker, and warm-hearted supporter this book could not possibly have been completed.</i></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?e8617a6a